/**
 * @generated SignedSource<<677ca3c173ba80120486981d78e362ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MilestonePickerMilestone$data = {
  readonly closed: boolean;
  readonly dueOn: string | null | undefined;
  readonly id: string;
  readonly progressPercentage: number;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "MilestonePickerMilestone";
};
export type MilestonePickerMilestone$key = {
  readonly " $data"?: MilestonePickerMilestone$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestonePickerMilestone">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MilestonePickerMilestone"
};

(node as any).hash = "6e60a0afad7137ee439461ddc4a8d63e";

export default node;
